import { useAuthStore } from "@/modules/auth/store";
import { useCookies } from "@/composables";
import { tokenKey } from "@/enums";

/**
 * Auth middleware для проверки авторизации пользователя
 * @param {Object} to - целевой роут
 * @param {Object} from - исходный роут
 * @param {Function} next - функция для продолжения навигации
 */
export const authMiddleware = async (to, from, next) => {
  const authStore = useAuthStore();
  const cookies = useCookies();
  const token = cookies.get(tokenKey);

  // Если пользователь уже авторизован и пытается попасть на страницу авторизации
  if (token && to.meta.authPage) {
    return next({ name: "main" });
  }

  // Если страница требует авторизации
  if (to.meta.authRequired) {
    // Проверяем наличие токена
    if (!token) {
      return next({ name: "login" });
    }

    // Если токен есть, но нет данных пользователя - делаем запрос
    if (!authStore.user) {
      try {
        await authStore.getMe();

        // Если успешно получили пользователя - разрешаем переход
        if (authStore.user) {
          return next();
        } else {
          // Если запрос не вернул пользователя - делаем logout и редирект на логин
          authStore.logout();
          return next({ name: "login" });
        }
      } catch (error) {
        // Если ошибка - делаем logout и запрещаем переход
        authStore.logout();
        return next({ name: "login" });
      }
    }
  }

  // Во всех остальных случаях разрешаем переход
  next();
};
